// eslint-disable-next-line import/prefer-default-export
export const autoResizeRem = (doc: Document, win: Window) => {
  const docEI = doc.documentElement;
  const resizeEvt =
    'orientationchange' in window ? 'orientataionchange' : 'resize';
  const recalc = () => {
    const { clientWidth } = docEI;
    if (!clientWidth) return;
    docEI.style.fontSize = `${100 * (clientWidth / 1440)}px`;
  };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
};
